<script>
  import AdoptableCard from "../components/AdoptableCard.svelte";
  import HeaderMini from "../components/HeaderMini.svelte";
  import Footer from "../components/Footer.svelte";
  import { Collapsible } from "spaper";
  import { Icon } from "svelte-awesome";
  import {
    faDog,
    faCat,
    faVenus,
    faMars,
    faEye,
    faEyeSlash,
    faSyncAlt,
    faArrowDown
  } from "@fortawesome/free-solid-svg-icons";
  import { strings } from "../constants/strings";
  import { isAdmin, surveyFilters } from "../stores/stores";
  import { getAdoptables, showErrorThenCallback } from "../utils/utils";
  import { navigate } from "svelte-routing";

  // Filters
  const filters = {
    male: true,
    dog: true,
    published: true,
  };
  let filtersOpen = false;
  let filtersTitle = strings.filtersTitle.closed;
  // Get adoptables on switch change
  $: {
    filters;
    refreshAdoptables();
  };

  $: {
    filtersTitle = filtersOpen
    ? strings.filtersTitle.opened
    : strings.filtersTitle.closed;
  };

  let adoptables = [];
  let currentPage = 0;
  let moreAdoptables = false;
  let noAdoptablesMessage = "";
  const getFiltersAsParams = () => {
    const kind = filters.dog ? "dog" : "cat";
    const sex = filters.male ? "male" : "female";
    if ($isAdmin) {
      return `kind=${kind}&sex=${sex}&published=${filters.published}&p=${currentPage}`;
    }
    return `kind=${kind}&sex=${sex}&p=${currentPage}`;
  };

  const refreshAdoptables = async () => {
    try {
      let resp;
      if ($surveyFilters) {
        resp = await getAdoptables($surveyFilters);
      } else {
        resp = await getAdoptables(getFiltersAsParams());
      }
      moreAdoptables = resp.remaining;
      adoptables = resp.adoptables;
      if (adoptables.length == 0) {
        noAdoptablesMessage =
          strings.genericMessages.warning.noMatchingAdoptables;
      }
    } catch (errorMessage) {
      showErrorThenCallback(errorMessage, () => {
        navigate("/");
      });
    }
  };

  const swapValues = (field) => {
    filters[field] = !filters[field];
  };

  const loadMore = async () => {
    currentPage += 1;
    try {
      let resp;
      if ($surveyFilters) {
        resp = await getAdoptables(`${$surveyFilters}&p=${currentPage}`);
      } else {
        resp = await getAdoptables(getFiltersAsParams());
      }
      moreAdoptables = resp.remaining;
      adoptables = [...adoptables, ...resp.adoptables];
    } catch (errorMessage) {
      showErrorThenCallback(errorMessage, () => {
        navigate("/");
      });
    }
  };
</script>

<HeaderMini />
<div class="adoptables-dashboard">
  {#if !$surveyFilters}
    <Collapsible label={filtersTitle} bind:open={filtersOpen}>
      <div class="row">
        <div class="sm-4 col search-filters">
          <div
            on:click={() => {
              swapValues("male");
            }}
            style="width:100%"
          >
            <Icon scale="4" data={filters.male ? faMars : faVenus} />
            <p>{filters.male ? "Macho" : "Hembra"}</p>
            <Icon scale="1" data={faSyncAlt} />
          </div>
        </div>
        <div class="sm-4 col search-filters">
          {#if $isAdmin}
            <div
              on:click={() => {
                swapValues("published");
              }}
            >
              <Icon scale="4" data={filters.published ? faEye : faEyeSlash} />
              <p>{filters.published ? "Publicado" : "Oculto"}</p>
              <Icon scale="1" data={faSyncAlt} />
            </div>
          {/if}
        </div>
        <div class="sm-4 col search-filters">
          <div
            on:click={() => {
              swapValues("dog");
            }}
          >
            <Icon scale="4" data={filters.dog ? faDog : faCat} />
            <p>{filters.dog ? "Perro" : "Gato"}</p>
            <Icon scale="1" data={faSyncAlt} />
          </div>
        </div>
      </div>
    </Collapsible>
  {:else if adoptables.length > 0}
    <div class="row">
      <div class="col-fill col">
        <h3>Ideales para ti</h3>
      </div>
    </div>
  {/if}
</div>
<div class="row">
  {#if $isAdmin}
    <div class="sm-3 col">
      <AdoptableCard
        title="Administrador"
        to="_admin"
        image="images/home_icon.png"
      />
    </div>
  {/if}
  {#if adoptables.length > 0}
    {#each adoptables as adp}
      <div class="sm-3 col">
        <AdoptableCard
          title={adp.name}
          to="adoptable/{adp.kind}/{adp._id}"
          image={`${adp.image}`}
        />
      </div>
    {/each}
  {:else}
    <div class="col-12 col">
      <h2>{noAdoptablesMessage}</h2>
    </div>
  {/if}
</div>
{#if moreAdoptables}
  <div class="row">
    <div class="col-fill col btn-load-more" on:click={loadMore}>
      <p>
        Ver más
      </p>
      <Icon scale="1" data={faArrowDown} />
    </div>
  </div>
{/if}
<Footer />

<style>
  .adoptables-dashboard {
    margin: auto;
    text-align: center;
    width: 30%;
  }

  @media screen and (max-width: 767px) {
    .search-filters {
      font-size: small;
    }
  }
  h2 {
    text-align: center;
  }

  .btn-load-more {
    text-align: center;
    display: block;
    margin: auto;
  }
</style>
